/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Accedi a risorse e materiali di supporto per CamAPS FX e CamAPS Liberty®.',
    keywords: 'biblioteca camaps, camaps fx, camaps liberty, risorse di supporto, gestione del diabete',
    localeMeta: 'it_it',

    bannerTitle: 'Supporto oltre i numeri',
    bannerSubtitle: 'con CamAPS Liberty<sup>®</sup>',
    bannerDescription: "Quando attivato, gli utenti non dovranno contare i carboidrati e somministrare un bolo pre-pasto.",
    bannerCompatibility: 'Compatibile con Android e iOS',
    
    announcementText: 'Ora disponibile su myLoop',
    announcementDisclaimer: '',

    introTitle: 'La prima funzione a fully closed-loop. Quando ne hai bisogno.',
    introDescription: 'Quando attivata, gli utenti non dovranno contare i carboidrati e somministrare un bolo di insulina pre-pasto.',
    introSubtext: 'Disponibile sui sistemi operativi Android e Apple',

    howItWorksTitle: 'Come funziona?',
    howItWorksDescription: 'Alimentato da una versione più proattiva dell\'algoritmo CamAPS. CamAPS Liberty anticipa e risponde ai cambiamenti del glucosio mantenendo i limiti di sicurezza stabiliti.',
    
    step1Title: 'PASSO 1',
    step1Description: 'Dalla schermata iniziale, vai al menu delle impostazioni.',
    step2Title: 'PASSO 2',
    step2Description: 'Scorri verso il basso e tocca l\'interruttore per attivare.',
    step3Title: 'PASSO 3',
    step3Description: 'Al primo utilizzo, dovrai guardare il nostro video esplicativo su CamAPS Liberty.',
    step4Title: 'PASSO 4',
    step4Description: 'Conferma di non avere meno di 13 anni e di non essere incinta.',
    step5Title: 'PASSO 5',
    step5Description: 'Tocca nuovamente l\'interruttore per attivare.',
    step6Title: 'PASSO 6',
    step6Description: "Tutto pronto. L'icona CamAPS Liberty apparirà sulla schermata iniziale<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Funziona solo quando la \"Auto mode\" è attiva",

    eligibilityTitle: 'Chi può usare CamAPS Liberty?',
    eligibilityCriterion1: 'Utenti esistenti con diabete di tipo 1',
    eligibilityCriterion2: '13 anni e oltre',
    eligibilityCriterion3: 'Incinta',
    parentsCarersTitle: 'E per quanto riguarda genitori e caregiver?',
    parentsCarersBlockTitle: 'Funzione "Blocco":',
    parentsCarersBlockDescription: 'Per evitare utilizzi accidentali',
    parentsCarersRemoteTitle: 'Monitoraggio remoto:',
    parentsCarersRemoteDescription: 'Companion, Glooko® e report PDF CamAPS di 2 settimane',

    imageOverlayText: 'Progettato per funzionare insieme al tuo attuale piano di gestione del diabete; non per sostituirlo.',
    
    usingTitle: 'Utilizzo di CamAPS Liberty',
    
    treatmentPlanText: 'CamAPS Liberty è progettata per eliminare la necessità di somministrare regolarmente boli ai pasti. Non sostituisce gli altri elementi del piano di gestione del diabete dell’utente, comprese le valutazioni periodiche con il team diabetologico.',
    
    usingLibertyTitle: 'Guarda e scopri CamAPS Liberty',
    usingLibertyDescription: 'Esplora i video per saperne di più su CamAPS Liberty e su come iniziare.',
    // latestVideoLabel removed
    moreVideosLabel: 'Altri video',
    factsheetDownloadText: 'Scheda informativa CamAPS Liberty (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_it.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Per iniziare',
        description: 'Candice Ward spiega come configurare e iniziare a usare CamAPS Liberty.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/A7yMmg3TVHk',
            title: 'Consigli pratici: CamAPS Liberty',
            duration: '02:09',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Presentazione di CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'Quella sensazione di fully closed-loop',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/gW6dTW0ZoW0',
            title: 'La funzione CamAPS Liberty',
            duration: '03:30',
        }
    ],
    
    whatHappensNextTitle: 'Cosa succede dopo?',
    whatHappensNextText: 'Eseguiremo un pilota in un unico mercato nei prossimi mesi. Resta sintonizzato per maggiori dettagli.',
};

